export const getMaybeCombinedError = (errors: (Error | undefined)[]): Error | undefined => {
	let firstErrorDetected = false;
	const combinedErrorMessages = errors.reduce((acc, maybeError) => {
		if (maybeError == null) {
			return acc;
		}

		const accumulatedMessage = `${acc}${firstErrorDetected ? ', ' : ''}Error: ${
			maybeError.message
		}`;
		firstErrorDetected = true;

		return accumulatedMessage;
	}, '');

	if (!firstErrorDetected) {
		return undefined;
	}

	return new Error(combinedErrorMessages);
};
